
import { waitFor } from '@codeleap/common'
import { getImpersonationToken } from './views'
import { logout } from './logout'
import { getFirebase } from '../../firebaseApp'
import { refreshWindow } from '@/utils'
import { impersonateStore } from '@/stores'
import { useMutation } from '@tanstack/react-query'

export const useImpersonate = () => {
  const isImpersonating = impersonateStore.useIsImpersonating()

  const mut = useMutation({
    mutationFn: async (params: Parameters<typeof getImpersonationToken>[0]) => {
      const token = await getImpersonationToken(params)

      await logout()

      const firebase = await getFirebase()

      await firebase.auth().signInWithCustomToken(
        token,
      )

      impersonateStore.impersonating.set({
        isImpersonating: true,
      })

      await waitFor(500) // Enough time to persist...

      refreshWindow()
    },
    onError(e) {
      alert('Error impersonating')
      console.error(e)
    },
  })

  const onImpersonate = mut.mutateAsync

  const stop = async () => {
    impersonateStore.stopImpersonating()
    await logout()
  }

  return {
    onImpersonate,
    stop,
    isImpersonating,
    loading: mut.isPending,
  }
}
